import { useHeaders } from "hooks/api/useHeaders";
import { useQuery } from "react-query";
import { downloadMaterialsReq, DownloadType } from "api";

export const useDownloadMaterials = (type: DownloadType, id: number) => {
    const headers = useHeaders();

    return useQuery(["downloadMaterials", id], () => downloadMaterialsReq(headers, type, { id }), { enabled: false });
};
